import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "back",
  "use": "back-usage",
  "viewBox": "0 0 51 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 51 32\" id=\"back\">\r\n<title>back</title>\r\n<path d=\"M15.889 32.086l-16-16 16-16 3.143 2.857-12.857 13.143 12.857 12.857z\" />\r\n<path d=\"M5.317 14.086h46v4.286h-46v-4.286z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol